// extracted by mini-css-extract-plugin
module.exports = {"inc-btn":"CounterButton_inc-btn__aqEuC","inc-dec-btn":"CounterButton_inc-dec-btn__btPRQ","count":"CounterButton_count__4jUM4"};